import React, { useState, useEffect } from 'react';
import {Link} from 'react-router-dom'

function CustomCardsItem2 (props){
    const [showFlag, setShowFlag] = useState("0");

    const showDivByStrInfo = (value) => {
        setShowFlag(value);
    };
    return (
        <>
        <div className="">
            <li className="cards__item">
                <div className="custom_cards__item__link">
                    <figure className="custom_cards__item__pic-wrap">
                        <Link style={{
                            backgroundColor: "white",
                        }} to={props.path}>
                            <img src={props.src} alt='Travel Image'
                            className="cards__item__img" />
                        </Link>
                    </figure>
                    <div className="custom_cards__item__info">
                        <label className="custom_cards__item__title">{props.title}</label>
                    </div>
                    <div className="custom_cards__item__info_text">
                        <label className="custom_cards__item__text" style={{
                            fontSize: "22px",
                        }} >{props.text}</label>
                    </div>
                    <div className="custom_cards__item__info3">
                        <label className="custom_cards__item__content"  style={{
                            fontSize: "16px",
                        }} >{props.content}</label>
                    </div>
                    <div className="custom_cards__item__button_div" style={{
                        display:props.hiddenButton=='true'?"none":""}}>
                        <div className="inoneline">
                            {/*<a onClick={() => showDivByStrInfo(props.showdiv)}>*/}
                                {/*<button className='custom_cards__item__button'>Overview of Topics</button>*/}
                            {/*</a>*/}
                            <Link style={{
                                backgroundColor: "white",
                            }} to={props.path}>
                                <button className='custom_cards__item__button'>Learn More</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </li>
        </div>

        </>
    )
}

export default CustomCardsItem2